import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="columns-3, layout, third" maskId="round-filled-radius-1-stroke-1.5-IconColumns3"><path d="M8 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H8V21Z" fill="currentColor"/><path d="M14.5 3V21H9.5V3H14.5Z" fill="currentColor"/><path d="M19.25 3C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H16V3H19.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
